import { useTranslation } from 'react-i18next'
import { ExtendedOption, AccessProfile } from 'shared/types'

interface ProfileWithDetails extends AccessProfile {
  disabled?: boolean
}

export const useMapProfileToExtendedOption = () => {
  const { t } = useTranslation()
  const mapProfileToOption = ({
    name: title,
    id: value,
    description,
    disabled,
  }: ProfileWithDetails): ExtendedOption<string, string> => {
    if (!title)
      return {
        title: t('anonymousUser'),
        value,
      }
    return {
      title: title || '',
      subtitle: description || undefined,
      value,
      disabled,
    }
  }

  return mapProfileToOption
}
